import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { number_format, num_word } from '../../tools/functions';
import { closeHeaderCatalog, clearHeaderMenuDropdown, clearSearch } from '../../tools/functions';

export const HeaderFixedBasket = {
    computed: {
        ...mapState(vplSiteStore, ['basket', 'SITE_TEMPLATE_PATH'])
    },
    methods: {

    },
    mounted(){

    },
    updated(){

    },
    template: `
            <a href="/cart/" class="burger__dropdown-basket">
              <svg class="icon icon-basket"><use xlink:href="#icon-basket"></use></svg>
              <span v-if="this.basket !== undefined && this.basket !== null && Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0)" class="burger__dropdown-basket-amount">
                {{ (this.basket !== undefined && this.basket !== null ? Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0) : '0') }}
              </span>
            </a>
    `
}
